import * as React from 'react'

import { useAuth } from '@app/state/authenticate/hooks'

import history from './history'

interface Props {
  authedRedirectTo: string
  children: React.ReactNode
}

export const RouteAuthed = ({ authedRedirectTo, children }: Props) => {
  const auth = useAuth()

  React.useEffect(() => {
    if (auth.isAuthenticated) {
      history.push(authedRedirectTo)
    }
  }, [auth.isAuthenticated, authedRedirectTo])

  return (
    <React.Fragment>{auth.isAuthenticated ? null : children}</React.Fragment>
  )
}
